
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMCases, SMTeammates, SMUser } from "@/store";

import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";

import { SUCCESS_NOTIFICATION_TYPE } from "@/constants/notification";
import { API_ROUTES } from "@/utils/API";
import { TSponsorshipCandidates_Table } from "@/models/company_sponsorship_candidates";
import { RCandidateProfile } from "@/modules/Services/Template/views/Candidates/Profile/RCandidateProfile";
import { STEPS_FOR_EDITING } from "@/constants/services";

const VALUE_NAME = "name";
const VALUE_EMAIL = "email";

@Component
export default class TeammatesPendingInvitesTable extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly items!: any[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  removeCandidatePopup = false;

  warningPopupType = WARNING_POPUP_TYPE;

  get caseId() {
    return Number(this.$route.params.id ?? 0);
  }

  userId = 0;

  isNotCurrentUser(id: number) {
    return SMUser.user?.ID !== id;
  }

  get isRelevantStepsForEditing() {
    if (SMUser.isExpert) return true;

    return STEPS_FOR_EDITING.includes(SMCases.caseStepName);
  }

  removeCandidateEnable(id: number) {
    return this.isNotCurrentUser(id) && this.isRelevantStepsForEditing;
  }

  popup = {
    toName: "",
  };

  $refs!: {
    label: HTMLElement;
  };

  openRemoveCandidatePopup(id: number) {
    this.userId = id;

    this.removeCandidatePopup = true;
  }

  closeRemoveCandidatePopup() {
    this.removeCandidatePopup = false;
  }

  get deleteLoading() {
    return SMTeammates.deleteLoading;
  }

  async removeCandidate() {
    const { caseId, userId } = this;

    if (!caseId || !userId) return;

    await this.axios.delete(API_ROUTES.COMPANY_REMOVE_SPONSORSHIP_CANDIDATE(caseId, userId));

    this.$root.$emit("show-notification", {
      type: SUCCESS_NOTIFICATION_TYPE,
      title: this.$tc("notification.candidateIsRemoved"),
    });

    this.$emit("update");

    this.closeRemoveCandidatePopup();
  }

  get attributes() {
    const { headers, items, loading, labels } = this;

    return {
      headers,
      items,
      loading,
      labels,
    };
  }

  get labels() {
    return {
      allLabel: this.$t("table.allLabel"),
      placeholderLabel: this.$t("table.placeholderLabel"),
    };
  }

  headers = [
    {
      text: this.$t("table.headers.name"),
      value: VALUE_NAME,
      sortable: true,
      sortBy: "text",
    },
    {
      text: this.$t("table.headers.email"),
      value: VALUE_EMAIL,
      sortable: true,
      sortBy: "text",
    },
  ];

  async navigateToSponsoredCandidate(item: TSponsorshipCandidates_Table) {
    if (!item.id) return;

    const { id } = item;

    await this.$router.push({
      name: RCandidateProfile.name,
      params: {
        sponsorship_candidate_id: String(id),
      },
    });
  }
}
